import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useTimer } from 'react-timer-hook';

import { useReveal } from 'modules/Room/Hooks/useReveal';

import PrimaryButton from 'shared/components/ui/PrimaryButton/PrimaryButton';
import { useAccount } from 'shared/hooks/use-web3';
import { usePlayerGamesStore } from 'shared/store/playerGamesStore';
import { useRoomStore } from 'shared/store/roomStore';

interface IRevealBtnProps {
  className?: string;
}

export const RevealBtn = ({ className }: IRevealBtnProps) => {
  const { writeReveal } = useReveal();
  const { activeRoomId } = useParams();
  const { address, chainId } = useAccount();
  const { roundCounter } = useRoomStore();
  const { playMoves } = usePlayerGamesStore();

  const revealKey = useMemo(
    () => activeRoomId + address + chainId + roundCounter,
    [activeRoomId, address, chainId, roundCounter],
  );

  const revealHash = playMoves?.[revealKey]?.revealHash?.hash as `0x${string}` | undefined;
  const expiry = useMemo(() => new Date(Date.now() + 10_000), [revealKey]);
  const { isRunning, restart } = useTimer({
    expiryTimestamp: expiry,
  });
  useEffect(() => {
    restart(expiry, true);
  }, [expiry, restart]);

  const loading = isRunning || !!revealHash;

  return (
    <PrimaryButton
      className={className}
      text="common.reveal"
      onClick={writeReveal}
      isLoading={loading}
      disabled={loading}
    />
  );
};
